import { httpClient } from '@/core/api/httpClient';
import { API_V1 } from '@/core/api/endpoints';
import type { DataResponse } from '@/shared/hooks/useDataSource.types';
import type { MemberDto, MemberDtoPagedResult } from '@/features/members/public';

export interface OrgMemberOption {
  id: string;
  label: string;
  description?: string;
  avatarUrl?: string;
  color?: string;
}

export async function searchOrgMembers(params: {
  search: string;
  cursor?: string;
  pageSize: number;
}): Promise<DataResponse<OrgMemberOption>> {
  // The backend paginates by page number, not cursor — the combobox's cursor
  // contract is satisfied by encoding the next page number as the cursor string.
  const page = params.cursor ? Number(params.cursor) : 1;

  const { data } = await httpClient.get<MemberDtoPagedResult>(`${API_V1}/tenants/members`, {
    params: {
      SearchTerm: params.search || undefined,
      Page: page,
      PageSize: params.pageSize,
    },
  });

  const items = (data.items ?? []).map<OrgMemberOption>((m: MemberDto) => ({
    id: m.user.userId ?? m.id ?? '',
    label: m.user.displayName ?? m.user.email ?? '',
    description: m.user.email ?? undefined,
    avatarUrl: m.user.avatarUrl ?? undefined,
  }));

  const hasNextPage = page < (data.totalPages ?? 1);

  return {
    items,
    total: data.totalCount,
    totalPages: data.totalPages,
    nextCursor: hasNextPage ? String(page + 1) : undefined,
  };
}
